/**
 * Maps an INSEE legal category (« catégorie juridique », 4 digits, returned by the
 * companies directory as natureJuridiqueCode) to a code of the LegalForm referential.
 * Only unambiguous categories are mapped; anything else returns null so the field is
 * left for the user to choose.
 */
const legalFormCodeForCategory = (category: string): string | null => {
  if (category === '6540') return 'SCI';
  if (category === '5710') return 'SAS';
  if (category === '5720') return 'SASU';
  if (category === '5498') return 'EURL';
  if (category.startsWith('54')) return 'SARL';
  if (category.startsWith('55') || category.startsWith('56')) return 'SA';
  if (category === '9110') return 'SYN';
  if (category === '9150') return 'ASL';
  if (category.startsWith('92')) return 'ASSO';
  return null;
};

/**
 * Returns the LegalForm referential code for the directory legal category, or null when
 * the category is unknown or its code is not part of the loaded referential.
 */
export const legalFormCodeFromNatureJuridique = (
  natureJuridiqueCode: string | null | undefined,
  knownCodes: readonly string[]
): string | null => {
  const category = natureJuridiqueCode?.trim();
  if (!category || !/^\d{4}$/.test(category)) return null;
  const code = legalFormCodeForCategory(category);
  return code && knownCodes.includes(code) ? code : null;
};
